import ArrangementSelectedPackage from './ArrangementSelectedPackage';

export default ArrangementSelectedPackage;
